<template>
  <div class="list-card van-hairline--surround" @click="linkTo">
    <div class="list-line clear">
      <p class="list-title fl">姓名:</p>
      <p class="list-content fl">{{item.name||''}}</p>
    </div>
    <div class="list-line clear">
      <p class="list-title fl">性别:</p>
      <p class="list-content fl">{{item.gender=='0'?'男':'女'}}</p>
    </div>
    <div class="list-line clear">
      <p class="list-title fl">手机号:</p>
      <p class="list-content fl">{{item.mobile||''}}</p>
    </div>
    <div class="list-line clear">
      <p class="list-title fl">{{item.birthday?'生日':item.weddingDate?'结婚纪念日':''}}:</p>
      <p class="list-content fl">{{item.birthday?item.birthday:item.weddingDate?item.weddingDate:''}}</p>
    </div>
    <div class="list-line clear">
      <p class="list-title fl">VIP等级:</p>
      <p class="VIP-starts fl"  v-if="item.vip" :style="'width:'+item.vip*.4+'rem'">
        <img
        v-for="(item,index) in item.vip"
        v-bind:key="index"
        :src="require('@/assets/img/vipStar.png')"
        class="start"
        alt=""
        srcset=""
        >
      </p>
    </div>

  </div>
</template>
<script>
  export default{
    data(){
      return {}
    },
    props:{
      item:Object,
      menuId : ''
    },
    methods:{
      linkTo(){
        this.$router.push('/ClientDetails?custId='+this.item.accountId)
      }
    }
  }
</script>
<style lang="less" src="~p/pageView-clientCare.less">

</style>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../../style/pageStyle/pageView-activeList.less";
</style>



// WEBPACK FOOTER //
// src/components/reports/components/clientCareCard.vue